import React, { useEffect, useState } from "react";
import {
  FormControl,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import localize from "../../../common/localize";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";
import { MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION } from "../../../common/utils";
import CreatedByText from "../../../components/common/CreatedByText";

export default function AddOrEditAdditionalNewness({ model, setModel }) {
  const [descriptionCount, setDescriptionCount] = useState(0);
  const maximumCharactersForDescription =
    MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION;

  useEffect(() => {
    if (model.Description) {
      setDescriptionCount(model.Description.length);
    }
  }, [model?.Description]);

  const handleChange = (e) => {
    setModel({
      ...model,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheckedChanged = (e) => {
    setModel({
      ...model,
      [e.target.name]: e.target.checked,
    });
  };

  return (
    <div style={{ width: "100%" }}>
      <form className="w-full">
        <div className="flex flex-wrap mb-6 mt-2">
          <FormControl fullWidth>
            <TextField
              required
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              size="small"
              fullWidth
              id="outlined-basic"
              name="Name"
              label={localize.name}
              variant="outlined"
              onChange={handleChange}
              value={model.Name}
            />
          </FormControl>
        </div>

        <div className="flex flex-wrap mb-2">
          <FormControl fullWidth>
            <TextField
              InputLabelProps={getInputLabelProps()}
              inputProps={{
                style: {
                  fontSize: "0.8em",
                },
                maxLength: maximumCharactersForDescription,
              }}
              size="small"
              fullWidth
              multiline
              rows={6}
              id="outlined-basic"
              name="Description"
              label={localize.description}
              variant="outlined"
              onChange={handleChange}
              value={model.Description}
              helperText={`${descriptionCount}/${maximumCharactersForDescription}`}
            />
          </FormControl>
        </div>

        <div className="w-full">
          <FormControlLabel
            size="small"
            name="NeedObservation"
            control={
              <Checkbox
                size="small"
                name="NeedObservation"
                checked={model.NeedObservation}
                onChange={handleCheckedChanged}
              />
            }
            label={
              <span style={{ fontSize: "0.8em" }}>
                {localize.need_observation}
              </span>
            }
          />
        </div>
      </form>

      <CreatedByText entity={model} />
    </div>
  );
}
